<template>
  <el-tabs v-model="activeName" @tab-remove="removeTab">
    <el-tab-pane label="待确认" name="list">
      <List ref="list" :addBtn="addBtn"/>
    </el-tab-pane>
    <el-tab-pane label="待寄出" name="history">
      <History ref="history" :addBtn="addBtn"/>
    </el-tab-pane>
    <el-tab-pane v-if="listBillPage" label="寻样确认" name="listBill" closable>
      <ListBill ref="listBill" :removeTab="removeTab"/>
    </el-tab-pane>
    <el-tab-pane v-if="historyBillPage" label="样品寄出" name="historyBill" closable>
      <HistoryBill ref="historyBill" :removeTab="removeTab"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List';
import History from './History';
import ListBill from './ListBill';
import HistoryBill from './HistoryBill'

export default {
  name: 'sample-confirm',
  components: {
    List,
    History,
    ListBill,
    HistoryBill
  },
  data() {
    return {
      activeName: 'list',
      listBillPage: false,
      historyBillPage: false,
    };
  },
  watch: {
    activeName(val) {
      if (val === 'list' || val === 'history') {
        this.$refs[val].getList();
      }
    },
  },
  methods: {
    removeTab(val, name) {
      this[`${val}Page`] = false;
      name ? this.activeName = name : this.activeName = 'list';
      this.$refs[this.activeName].getList();
    },
    addBtn(val, data) {
      this[`${val}Page`] = true;
      this.activeName = val;
      this.$nextTick(()=> {
        this.$refs[val].getListForm(data);
      })
    },
  },
};
</script>
